import { loadStripe } from "@stripe/stripe-js/pure";

let stripePromise;
export const getStripePromise = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
};
